import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Pages
import Home from '@/views/Home'

import Category from '@/views/Category'
import Product from '@/views/Product'

import Categories from '@/views/Categories'
import Products from '@/views/Products'

import AuthCallback from "@/auth/AuthCallback"


const router =  new Router({
  mode: "history",
  routes: [
    {
      path: '/auth/callback',
      name: 'AuthCallback',
      component: AuthCallback
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories
    },
    { path: '/categories/:id',
    component: Category,
    name: "Category",
    props: true },
    { path: '/products/:id',
    component: Product,
    name: "Product",
    props: true },
    {
      path: '/products',
      name: 'Products',
      component: Products
    }
  ]
})

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  if(to.name == 'AuthCallback') { // check if "to"-route is "callback" and allow access
    next()
  } else if (router.app.$auth.isAuthenticated()) { // if authenticated allow access
    next()
  } else { // trigger auth0 login
    router.app.$auth.login()
  }
})

export default router
